import { useSuspenseQuery } from "@tanstack/react-query";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";
import { useAxios } from "@wayflyer/auth-sdk";

import { AuthCallbackPath } from "../../constants/connector-callbacks";
import { FUNDING_APPLICATION_CONNECTORS_API } from "../../components/constants";
import { ConnectorCategory } from "../../types";

export const usePlatformConnectors = (
  customerDomain: string,
  params?: { category?: ConnectorCategory; skipConnections?: boolean; callbackPath?: AuthCallbackPath }
) => {
  const client = useAxios();
  const fetchUrl = FUNDING_APPLICATION_CONNECTORS_API.replace(":customerSlug", customerDomain);

  // create the query function
  const queryFn = () => client.get<FundingApplicationSchemas.ConnectorsListSchema>(fetchUrl, { params });
  return useSuspenseQuery({
    queryKey: [fetchUrl, params],
    queryFn,
    select: ({ data }) => data.connectors,
    refetchOnMount: "always",
  });
};
